import type { Text } from '@codemirror/state';
import type { TreeCursor } from '@lezer/common';

import { getTextFromRange } from './get-text.js';

/** @internal */
export function getStatementStatus(
  statementCursor: TreeCursor,
  doc?: Text,
): 'complete' | 'incomplete' | 'indeterminate' {
  let hasKey = false;
  let hasOperator = false;
  let hasValue = false;
  let key = '';

  const { to } = statementCursor.node;

  statementCursor.iterate((childNode) => {
    // TODO: remove once the lezer bugfix is released and our dependency updated.
    // The 'iterate' doc says 'Iterate over the current node and all its descendants', but it
    // continues also with siblings... This is to stop iterating once we leave the filter statement.
    if (childNode.from >= to) {
      return false;
    }

    switch (childNode.name) {
      case 'FilterKey':
        hasKey = true;

        if (doc) {
          key = getTextFromRange(childNode, doc);
        }
        break;
      case 'ComparisonOperator':
      case 'InclusionOperator':
        hasOperator = true;
        break;
      case 'ExistsOperator':
        hasOperator = true;
        hasValue = true;
        break;
      case 'FilterSimpleValue':
      case 'FilterIncludesValue':
        hasValue = true;
        break;
    }
  });

  if (hasKey && hasOperator && hasValue) {
    return 'complete';
  }

  // If the statement only has a key and it is 'o', we don't know if it is an OR operator
  // or an unfinished key so we consider it indeterminate.
  if (!hasOperator && !hasValue && hasKey && key === 'o') {
    return 'indeterminate';
  }

  return 'incomplete';
}
